import { useEffect } from 'react'

import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryApprovedExpenseItemCount } from '../../models/useQueryApprovedExpenseItemCount'

/**
 * Hook-only query presenter (ADR-2): exposes the approved expense item total
 * for the Expenses tab badge (BHV-005) and toasts fetch failures with the
 * parsed error message (BHV-027, ADR-10).
 */
export const useApprovedExpenseItemCountPresenter = () => {
  const intl = useProcurifyIntl()

  const { count, isLoading, error } = useQueryApprovedExpenseItemCount()

  useEffect(() => {
    if (!error) return

    toast.error({
      title: intl.formatMessage(messages.errorTitle),
      children:
        getMessageFromError(error) ??
        intl.formatMessage(messages.defaultErrorMessage),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return {
    data: {
      count,
    },
    states: {
      isLoading,
    },
  }
}
